module.exports = __webpack_public_path__ + "img/authorized-competitions-it.a7b24666.png";